import { Injectable } from '@angular/core';
import { Partner } from '@shared/entities/partner';
import { ApiService } from '@shared/services';
import { Observable, of, map, catchError } from 'rxjs';

const LOG_PREFIX = '[Api][PartnerContact] ';

@Injectable({
  providedIn: 'root'
})
export class PartnerContactService extends ApiService<Partner> {
  constructor() {
    super(Partner, '/partners', '/partners', undefined, 'partner-contact');
  }

  searchPartners(keyword: string): Observable<Partner[]> {
    this.logger.debug(LOG_PREFIX + 'searchPartners', keyword);

    this.removeUrlParameters(); // reset completo prima di impostare i nuovi parametri
    this.setUrlParameter('keyword', keyword);
    this.setUrlParameter('isPartner', 'true');
    this.setUrlParameter('showActivated', 'false');

    return this.paginate(Partner, 1, 10).pipe(
      map((response) => response.data || []),
      catchError((error) => {
        this.logger.error(LOG_PREFIX + 'searchPartners error', error);
        return of([]);
      })
    );
  }

  searchCustomerPartners(keyword: string): Observable<Partner[]> {
    this.logger.debug(LOG_PREFIX + 'searchCustomerPartners', keyword);

    this.removeUrlParameters(); // reset completo prima di impostare i nuovi parametri
    this.setUrlParameter('keyword', keyword);
    this.setUrlParameter('isPartner', 'false');
    this.setUrlParameter('showActivated', 'false');

    return this.paginate(Partner, 1, 10).pipe(
      map((response) => response.data || []),
      catchError((error) => {
        this.logger.error(LOG_PREFIX + 'searchCustomerPartners error', error);
        return of([]);
      })
    );
  }

  // CUSTOMER_PARTNER: tutti i record di SF_clienti_partner, senza filtro su Partner_c
  searchAllPartnerContacts(keyword: string): Observable<Partner[]> {
    this.logger.debug(LOG_PREFIX + 'searchAllPartnerContacts', keyword);

    this.removeUrlParameters();
    this.setUrlParameter('keyword', keyword);
    // isPartner non viene passato → nessun filtro su Partner_c → tutti i record
    this.setUrlParameter('showActivated', 'false');

    return this.paginate(Partner, 1, 10).pipe(
      map((response) => response.data || []),
      catchError((error) => {
        this.logger.error(LOG_PREFIX + 'searchAllPartnerContacts error', error);
        return of([]);
      })
    );
  }
}
